import LoadingSquare from "shared/components/loading/LoadingSquare.js";
import PopupAddMatchDossier from "shared/components/popups/PopupAddMatchDossier.js";
import PopupEditMatchDossier from "shared/components/popups/PopupEditMatchDossier.js";
import PopupPremiumInfo from "shared/components/popups/PopupPremiumInfo.js";
import { isUserPremium } from "shared/utils/user.js";
import "./ControllerSelector.css";

export const ControllerMatchDossierAddButton = ({ dossiers, user, afterAdd }) => (
  <div className="d-flex flex-shrink-0">
    {!isUserPremium(user) && dossiers && dossiers.length >= 3 ? (
      <PopupPremiumInfo
        trigger={
          <button
            type="button"
            className="btn btn-sm d-flex flex-column align-items-center justify-content-center m-0 premium-background"
            style={{ minWidth: 30, lineHeight: 1 }}
            title="Premium required"
            aria-label="Premium required to add a dossier"
          >
            <i className="bi bi-lock-fill"></i>
            <span style={{ fontSize: "10px" }}>({dossiers.length}/3)</span>
          </button>
        }
      />
    ) : (
      <PopupAddMatchDossier
        trigger={
          <button
            type="button"
            className="btn btn-sm d-flex flex-column align-items-center justify-content-center m-0 primary-color-background text-white"
            style={{ minWidth: 30, lineHeight: 1 }}
            title="Add dossier"
            aria-label="Add dossier"
          >
            <i className="bi bi-plus"></i>
            {!isUserPremium(user) && dossiers && <span style={{ fontSize: "10px" }}>({dossiers.length}/3)</span>}
          </button>
        }
        onClose={afterAdd}
      />
    )}
  </div>
);

const ControllerMatchDossier = ({
  onSelect,
  onSelect2,
  onMove,
  dossiers,
  selectedId,
  selectedId2,
  afterAdd,
  user,
  loadedMatches,
  setMatchesToLoad,
  onEditClose,
  onDelete,
  hideAddButton = false,
}) => {
  return (
    <div className="controller-selector d-flex flex-row align-items-start w-100">
      {!hideAddButton && (
        <div className="controller-selector-add">
          <ControllerMatchDossierAddButton dossiers={dossiers} user={user} afterAdd={afterAdd} />
        </div>
      )}

      <div className="controller-selector-items d-flex flex-row align-items-stretch">
        {dossiers !== null ? (
          dossiers.map((p, index) => (
            <div
              key={p.id}
              className="controller-selector-item Item d-flex align-items-stretch"
              style={{ minWidth: 0, padding: 0 }}
            >
              <div
                className="d-flex flex-column justify-content-center ps-2"
                style={{
                  cursor: "default",
                  minHeight: 60,
                  minWidth: 0,
                  flex: "1 1 0%",
                  opacity: "1 !important",
                  fontWeight: "bold",
                  fontSize: 16,
                  lineHeight: 1,
                }}
              >
                <div className="text-truncate w-100" title={p.name}>
                  {p.name}
                </div>
                <div className="w-100 text-truncate" style={{ fontSize: 11, opacity: 0.7 }}>
                  {p.matches?.length || 0} match(es)
                </div>
                <div className="w-100 text-truncate mt-1 d-flex flex-wrap" style={{ fontSize: 11, opacity: 0.7 }}>
                  <button
                    className={
                      "btn btn-info btn-xs text-white me-1 " +
                      (p.id === selectedId ? "main-pink-color-background" : "background-color")
                    }
                    onClick={() => onSelect(p.id)}
                  >
                    Selection 1
                  </button>
                  <button
                    className={
                      "btn btn-blue btn-xs text-white " +
                      (p.id === selectedId2 ? "main-blue-color-background" : "background-color")
                    }
                    onClick={() => onSelect2(p.id)}
                  >
                    Selection 2
                  </button>
                </div>
              </div>

              <div className="d-flex flex-column align-items-center justify-content-around flex-shrink-0 px-1">
                <PopupEditMatchDossier
                  dossier={p}
                  loadedMatches={loadedMatches}
                  trigger={
                    <button className="btn btn-sm text-main text-xs p-0" aria-label={`Edit ${p.name}`}>
                      <i className="bi bi-pencil-square" />
                    </button>
                  }
                  userId={user?.id}
                  onUpdate={afterAdd}
                  onClose={onEditClose}
                  onDelete={onDelete}
                  setMatchesToLoad={setMatchesToLoad}
                />
                <button
                  className="btn btn-sm p-0"
                  style={{
                    color: "#f86285",
                    opacity: index === 0 ? 0.3 : 1,
                    borderRadius: "50%",
                    width: 20,
                    height: 20,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    cursor: index === 0 ? "not-allowed" : "pointer",
                  }}
                  disabled={index === 0}
                  onClick={() => onMove(p.id, index - 1)}
                >
                  <i className="bi bi-caret-up-fill d-none d-md-block"></i>
                  <i className="bi bi-caret-left-fill d-block d-md-none"></i>
                </button>

                <button
                  className="btn btn-sm p-0"
                  style={{
                    color: "#f86285",
                    opacity: index === dossiers.length - 1 ? 0.3 : 1,
                    borderRadius: "50%",
                    width: 20,
                    height: 20,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    cursor: index === dossiers.length - 1 ? "not-allowed" : "pointer",
                  }}
                  disabled={index === dossiers.length - 1}
                  onClick={() => onMove(p.id, index + 1)}
                >
                  <i className="bi bi-caret-down-fill d-none d-md-block"></i>
                  <i className="bi bi-caret-right-fill d-block d-md-none"></i>
                </button>
              </div>
            </div>
          ))
        ) : (
          <div className="controller-selector-loading">
            <LoadingSquare height="60px" />
          </div>
        )}
      </div>
    </div>
  );
};

export default ControllerMatchDossier;
